// src/providers/logrocket.ts
import LogRocket from "logrocket";
var LOGROCKET_APP_ID = "rys1yn/appcues";
var isInitialized = false;
var initializeLogRocket = (config) => {
  if (isInitialized) {
    return;
  }
  if (!config.isProd) {
    return;
  }
  const appId = config.appId || LOGROCKET_APP_ID;
  if (!config.commitHash) {
    console.warn(
      '[LogRocket] COMMIT_HASH is undefined - sessions will be tagged as "unknown" release'
    );
  }
  LogRocket.init(appId, {
    release: config.commitHash || "unknown",
    console: {
      shouldAggregateConsoleErrors: true
    },
    rootHostname: ".appcues.com",
    shouldDebugLog: false,
    network: {
      requestSanitizer: (request) => {
        if (typeof request === "object" && request !== null && "headers" in request && typeof request.headers === "object" && request.headers !== null) {
          Object.keys(request.headers).forEach((key) => {
            if (key.toLowerCase() === "authorization") {
              request.headers[key] = "[REDACTED]";
            }
          });
        }
        return request;
      }
    }
  });
  isInitialized = true;
};
var identifyLogRocketUser = (userId, traits) => {
  if (!isInitialized) {
    return;
  }
  LogRocket.identify(userId, traits);
};
var trackLogRocketEvent = (eventName, properties) => {
  if (!isInitialized) {
    return;
  }
  LogRocket.track(
    eventName,
    properties
  );
};
var getLogRocketSessionURL = () => {
  if (!isInitialized) {
    return void 0;
  }
  return LogRocket.getSessionURL();
};
var _resetForTesting = () => {
  isInitialized = false;
};

export {
  initializeLogRocket,
  identifyLogRocketUser,
  trackLogRocketEvent,
  getLogRocketSessionURL,
  _resetForTesting
};
//# sourceMappingURL=chunk-HQNAMWRU.mjs.map